/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceTypeDto,
  DeviceType,
  DeviceTypesControllerCreateDeviceTypeV1PathParameters,
  DeviceTypesControllerDeleteV1PathParameters,
  DeviceTypesControllerFindDeviceTypesV1200,
  DeviceTypesControllerFindDeviceTypesV1PathParameters,
  DeviceTypesControllerUpdateV1PathParameters,
  UpdateDeviceTypeDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceTypesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all device types
   */

  findDeviceTypes<TData = DeviceTypesControllerFindDeviceTypesV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DeviceTypesControllerFindDeviceTypesV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-types`);
  }
  /**
   * @summary Create a new device type
   */

  createDeviceType<TData = DeviceType>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceTypesControllerCreateDeviceTypeV1PathParameters,
    createDeviceTypeDto: CreateDeviceTypeDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-types`, createDeviceTypeDto);
  }
  /**
   * @summary Update a device type
   */

  update<TData = DeviceType>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceTypesControllerUpdateV1PathParameters,
    updateDeviceTypeDto: UpdateDeviceTypeDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/device-types/${id}`, updateDeviceTypeDto);
  }
  /**
   * @summary Delete a device type
   */

  delete<TData = void>({ clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceTypesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-types/${id}`);
  }
}
